"use strict";
globalThis.Wizard = (() => {
  const { $, $$, hide, show, toggle, announce } = Utils;
  const state = State.wizard;
  const FLOWS = {
    kozijnen: ["0", "1", "2", "2b", "2c", "2e", "2d", "3a", "3", "media", "contact"],
    deuren: ["0", "1", "2-deuren", "2e", "2b-deuren", "2c-deuren", "media", "contact"],
    houtrot: ["0", "1", "2-houtrot", "media", "contact"],
    inspectie: ["0", "1", "contact"]
  };
  const STEP_LABELS = {
    "0": "Postcode",
    "1": "Dienst",
    "2": "Houtsoort",
    "2-deuren": "Afwerking",
    "2-houtrot": "Hoeveelheid",
    "2b": "Beglazing",
    "2b-deuren": "Montage",
    "2c": "Afwerking",
    "2c-deuren": "Details",
    "2d": "Montage",
    "2e": "RAL kleur",
    "3a": "Afmetingen",
    "3": "Indeling",
    "media": "Foto's",
    "contact": "Gegevens"
  };
  let els = null;
  const init = () => {
    els = {
      form: $("#offerte-wizard"),
      steps: {},
      progress: $("#wizard-progress"),
      stepLabel: $("#wizard-step-label"),
      backBtn: $("#mobile-back-btn"),
      desktopBackBtn: $("#wizard-back")
    };
    $$(".wizard-step").forEach((el) => {
      const id = el.id.replaceAll("wizard-step-", "");
      els.steps[id] = el;
    });
    els.backBtn?.addEventListener("click", goBack);
    els.desktopBackBtn?.addEventListener("click", goBack);
    initOptionStyles();
    state.subscribe(handleStateChange, ["step", "service"]);
    return { showStep, goBack, getCurrentStep, getFlow };
  };
  const getFlow = () => {
    const service = state.get("service");
    return FLOWS[service] || FLOWS.kozijnen;
  };
  const getStepIndex = (stepId) => getFlow().indexOf(String(stepId));
  const getTotalSteps = () => getFlow().length;
  const getCurrentStep = () => state.get("step");
  const showStep = (stepId, options = {}) => {
    const id = String(stepId);
    const stepEl = els.steps[id];
    if (!stepEl) {
      console.warn(`Step not found: ${id}`);
      return false;
    }
    const currentStep = state.get("step");
    if (!options.skipHistory && currentStep && currentStep !== id) {
      const history = state.get("history") || [];
      state.set("history", [...history, currentStep]);
    }
    Object.values(els.steps).forEach((el) => hide(el));
    show(stepEl);
    state.set("step", id);
    updateProgress(id);
    updateBackButton(id);
    const label = STEP_LABELS[id] || `Stap ${id}`;
    announce(`${label} - stap ${getStepIndex(id) + 1} van ${getTotalSteps()}`);
    stepEl.scrollTop = 0;
    globalThis.lucide?.createIcons();
    document.dispatchEvent(new CustomEvent("wizard:step-shown", {
      detail: { step: id, previousStep: currentStep }
    }));
    return true;
  };
  const goBack = () => {
    const history = state.get("history") || [];
    if (history.length === 0) return false;
    const prevStep = history.pop();
    state.set("history", history);
    return showStep(prevStep, { skipHistory: true });
  };
  const updateProgress = (stepId) => {
    const index = getStepIndex(stepId);
    const total = getTotalSteps();
    const percent = total > 1 ? (index + 1) / total * 100 : 100;
    if (els.progress) {
      els.progress.style.width = `${percent}%`;
    }
    if (els.stepLabel) {
      els.stepLabel.textContent = `Stap ${index + 1}`;
    }
  };
  const updateBackButton = (stepId) => {
    const history = state.get("history") || [];
    const visible = history.length > 0;
    toggle(els.backBtn, "visible", visible);
    toggle(els.backBtn, "opacity-0", !visible);
    toggle(els.backBtn, "pointer-events-none", !visible);
    if (els.desktopBackBtn) {
      els.desktopBackBtn.disabled = !visible;
      toggle(els.desktopBackBtn, "opacity-30", !visible);
      toggle(els.desktopBackBtn, "cursor-not-allowed", !visible);
    }
  };
  const handleStateChange = (key, value) => {
    if (key === "service" && value) {
      updateProgress(state.get("step"));
    }
  };
  const initOptionStyles = () => {
    const groups = [
      "wizard-hout",
      "wizard-glas",
      "wizard-afwerking",
      "wizard-ral",
      "wizard-montage",
      "wizard-deur-afwerking",
      "wizard-deur-montage",
      "wizard-deur-optie",
      "wizard-type",
      "wizard-type-3a",
      "wizard-door-type",
      "wizard-vakken"
    ];
    groups.forEach(updateGroupStyles);
    $$('.wizard-step input[type="radio"], .wizard-step input[type="checkbox"]').forEach((input) => {
      input.addEventListener("change", () => updateGroupStyles(input.name));
    });
  };
  const updateGroupStyles = (name) => {
    $$(`input[name="${name}"]`).forEach((input) => {
      const label = input.closest("label");
      if (!label) return;
      const wrapper = label.querySelector("div");
      const indicator = label.querySelector(".option-check");
      if (!wrapper) return;
      if (input.checked) {
        wrapper.classList.add("border-[#D40032]", "bg-[#D40032]/5");
        wrapper.classList.remove("border-neutral-200");
        if (indicator && !indicator.classList.contains("bg-green-100")) {
          indicator.classList.add("bg-[#D40032]", "border-[#D40032]");
          indicator.classList.remove("border-neutral-300");
          const icon = indicator.querySelector("i, svg");
          icon?.classList.remove("opacity-0");
        }
      } else {
        wrapper.classList.remove("border-[#D40032]", "bg-[#D40032]/5");
        wrapper.classList.add("border-neutral-200");
        if (indicator && !indicator.classList.contains("bg-green-100")) {
          indicator.classList.remove("bg-[#D40032]", "border-[#D40032]");
          indicator.classList.add("border-neutral-300");
          const icon = indicator.querySelector("i, svg");
          icon?.classList.add("opacity-0");
        }
      }
    });
  };
  const hasSelection = (name) => !!$(`input[name="${name}"]:checked`);
  const getSelected = (name) => $(`input[name="${name}"]:checked`)?.value || null;
  const refreshStyles = () => {
    initOptionStyles();
    globalThis.lucide?.createIcons();
  };
  const validateStep = (stepId) => {
    const config = globalThis.WizardConfig?.validation?.[stepId];
    if (!config) return true;
    const val = globalThis.Validation;
    if (!val) return true;
    const currentState = state.get();
    const stepEl = els.steps[stepId];
    val.clearInlineMessage(stepEl);
    let isValid = true;
    let errorMsg = config.message || "Maak een keuze om verder te gaan";
    if (config.rule === "required") {
      const value = currentState[config.field];
      isValid = value != null && String(value).trim() !== "";
    } else if (config.rule === "custom" && typeof config.validator === "function") {
      isValid = config.validator(currentState);
    } else if (config.rule === "postcode") {
      const value = currentState[config.field];
      isValid = val.rules.postcode()(value).valid;
    }
    if (!isValid) {
      val.showInlineMessage(stepEl, errorMsg);
      if (config.field) {
        const kebabField = config.field.replaceAll(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        const selector = `[name="wizard-${config.field}"], [name="wizard-${kebabField}"]`;
        const container = stepEl.querySelector(selector)?.closest(".wizard-option") || stepEl.querySelector(".space-y-3");
        val.highlightSelection(container);
      }
      return false;
    }
    return true;
  };
  const navigateNext = () => {
    const currentStepId = state.get("step");
    if (!globalThis.WizardConfig) {
      console.error("WizardConfig not found");
      return false;
    }
    if (!validateStep(currentStepId)) {
      return false;
    }
    const route = globalThis.WizardConfig.routes[currentStepId];
    if (!route) {
      console.error(`No route defined for step: ${currentStepId}`);
      return false;
    }
    let nextStepId = route;
    if (typeof route === "function") {
      nextStepId = route(state.get());
    }
    if (nextStepId) {
      return showStep(nextStepId);
    }
    return false;
  };
  return Object.freeze({
    init,
    showStep,
    navigateNext,
    goBack,
    getCurrentStep,
    getFlow,
    getStepIndex,
    getTotalSteps,
    hasSelection,
    getSelected,
    refreshStyles,
    updateGroupStyles
  });
})();
